import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import 'iview/dist/styles/iview.css';
import './assets/css/common.css'
import './index.less'
import moment from 'moment'
import axios from 'axios'
import ft from './filter/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.use(iView)

Vue.use(ElementUI);

//过滤器
for(let key in ft){
  Vue.filter(key, ft[key]);
}

//弹框提示
window.alert = (msg)=>{
  Vue.prototype.$Modal.info({
    title: '提示',
    content: msg
  });
}
window.confirm = (msg,cb)=>{
  Vue.prototype.$Modal.confirm({
    title: '提示',
    content: msg,
    onOk: () => {
      cb(true);
    },
    onCancel: () => {
      cb(false);
    }
  });
}
Vue.prototype.$Message.config({
  top: 80,
  duration: 3
});
window.msgSuccess = (msg)=>{
  Vue.prototype.$Message.success(msg);
}
window.msgError = (msg)=>{
  Vue.prototype.$Message.error(msg);
}
window.msgWarning = (msg)=>{
  Vue.prototype.$Message.warning(msg);
}

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js